import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { VisualPickerButtonContainer } from '../../../../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButtonContainer';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Lozenge } from '../../../../../../CommonComponents/OPL/Lozenge/Lozenge';
import { CardContent, CardHeader, CardWrapper } from './GoalCard.styles';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';
import { selectDisplayBehavioralFinanceSection } from '../../../../../../CommonSelectors/CommonAreaSelector';

interface Props {
  ctaText: string;
  onClick(): void;
  hideFooter: boolean;
  icon: React.ReactNode;
  children: React.ReactNode;
  title: string;
  isCompleted?: boolean;
  showCompletedLozenge?: boolean;
}

export const GoalCard = ({
  title,
  icon,
  ctaText,
  hideFooter,
  showCompletedLozenge,
  isCompleted,
  children,
  onClick,
}: Props) => {
  const DisplayBehavioralFinanceSection = useSelector(selectDisplayBehavioralFinanceSection);
  return (
    <Box as="li">
      <VisualPickerButtonContainer css="width: 100%; height: 100%" onClick={onClick}>
        <CardWrapper>
          <CardHeader>
            <Box display="flex" alignItems="flex-start" style={{ gap: 8, height: 48 }}>
              {icon}

              <Text
                fontSize={DisplayBehavioralFinanceSection ? 'h6' : 'h5'}
                fontWeight={600}
                isTruncated={DisplayBehavioralFinanceSection}
                css="white-space: normal;"
              >
                {title}
              </Text>
            </Box>

            {showCompletedLozenge && (
              <Lozenge variantColor={isCompleted ? 'primary' : 'default'} css="max-height: 24px">
                {isCompleted ? 'Completed' : 'Incomplete'}
              </Lozenge>
            )}
          </CardHeader>

          <CardContent>
            <Box>{children}</Box>

            {!hideFooter && (
              <Box display="flex" mt="16" alignItems="center">
                <Text color="primary.500" fontWeight={500} mr="8">
                  {ctaText}
                </Text>

                <Icon className="far fa-chevron-right" fontSize="small" color="primary.500" />
              </Box>
            )}
          </CardContent>
        </CardWrapper>
      </VisualPickerButtonContainer>
    </Box>
  );
};
